import {
  GET_LIST_PROMO_REQUEST,
  GET_LIST_PROMO_SUCCESS,
  GET_LIST_PROMO_FAIL,
  DELETE_LIST_PROMO_REQUEST,
  DELETE_LIST_PROMO_SUCCESS,
  DELETE_LIST_PROMO_FAIL,
  CREATE_PROMO_FAIL,
  CREATE_PROMO_SUCCESS,
  CREATE_PROMO_REQUEST,
  GET_DETAIL_PROMO_REQUEST,
  GET_DETAIL_PROMO_SUCCESS,
  GET_DETAIL_PROMO_FAIL,
  GET_LIST_EXPORT_PROMO_REQUEST,
  GET_LIST_EXPORT_PROMO_SUCCESS,
  GET_LIST_EXPORT_PROMO_FAIL,
  DOWNLOAD_EXPORT_PROMO_REQUEST,
  DOWNLOAD_EXPORT_PROMO_SUCCESS,
  DOWNLOAD_EXPORT_PROMO_FAIL
} from '../../constants/promo'

const initialState = {
  loading: false,
  loadingCrud: false,
  loadingDownload: false,
  promoList: [],
  promoExportList: [],
  promoDetail: {},
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  },
  pageableExport: {
    page: 1,
    size: 10,
    hits: 1
  },
  error: null
}

const promoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_PROMO_REQUEST:
      return { ...state, loading: true }
    case GET_LIST_PROMO_SUCCESS:
      return {
        ...state,
        loading: false,
        promoList: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_PROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        promoList: [],
        pageable: {
          page: 1,
          size: 10
        }
      }
    case GET_LIST_EXPORT_PROMO_REQUEST:
      return {
        ...state,
        loading: true,
        promoExportList: [],
        pageableExport: {
          page: 1,
          size: 10
        }
      }
    case GET_LIST_EXPORT_PROMO_SUCCESS:
      return {
        ...state,
        loading: false,
        promoExportList: action.payload,
        pageableExport: action.pageable
      }
    case GET_LIST_EXPORT_PROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        promoExportList: [],
        pageableExport: {
          page: 1,
          size: 10
        }
      }
    case DELETE_LIST_PROMO_REQUEST:
    case CREATE_PROMO_REQUEST:
      return { ...state, loadingCrud: true }
    case DELETE_LIST_PROMO_SUCCESS:
    case CREATE_PROMO_SUCCESS:
      return { ...state, loadingCrud: false }
    case DELETE_LIST_PROMO_FAIL:
    case CREATE_PROMO_FAIL:
      return { ...state, loadingCrud: false, error: action.payload }
    case GET_DETAIL_PROMO_REQUEST:
      return { ...state, loading: true, error: false }
    case GET_DETAIL_PROMO_SUCCESS:
      return { ...state, loading: false, promoDetail: action.payload, error: false }
    case GET_DETAIL_PROMO_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DOWNLOAD_EXPORT_PROMO_REQUEST:
      return { ...state, loadingDownload: true }
    case DOWNLOAD_EXPORT_PROMO_SUCCESS:
      return {
        ...state,
        loadingDownload: false
      }
    case DOWNLOAD_EXPORT_PROMO_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default promoReducer
